export const ROLES_FEATURE_KEY = 'roles';
